import { createContext, useContext } from "react";
import type { Venue } from "./schema";

export const useVenue = (): Venue => {
  const venue = useContext(VenueContext);
  if (!venue) {
    throw new Error("useVenue must be used within a VenueContext");
  }
  return venue;
};
export const VenueContext = createContext<Venue | null>(null);
